window.theme = window.theme || {}


theme.collectionFeaturedProduct = {
  register: function(collectionTitle, container){
    if(!container) container = "test-load-content"
    this.request = new XMLHttpRequest();
    this.request.onreadystatechange = function success() {
      if (this.request.readyState === 4 && this.request.status === 200) {
        var newContainer = this.request.responseXML.querySelectorAll("#AjaxinateLoop")[0];
        document.getElementById(container).insertAdjacentHTML('beforeend', newContainer.innerHTML);
        if(document.getElementById("collection-campaign-container")){
          document.getElementById("collection-campaign-container").style.display = "block"
        }
        
        setTimeout(formatedGridItemPrice, 60);
      }
    }.bind(this);
    this.request.open('GET', `/search?q=tag:"Featured" AND tag:"${collectionTitle}"`);
    this.request.responseType = 'document';
    this.request.send();
  },
  
  // Store pagination state
  paginationState: {},
  
  get(container, collectionTitle, row, limit, gridClass){
    const containerElement = document.getElementById(container)
    
    if(!containerElement) {
      console.error('Container element not found:', container);
      return;
    }
    
    // Initialize pagination state for this container
    this.paginationState[container] = {
      currentPage: 1,
      totalPages: 0,
      totalProducts: 0,
      isLoading: false,
      collectionHandle: collectionTitle
    };
    
    console.log('Loading featured products for collection:', collectionTitle);
    containerElement.innerHTML = '<div class="loading" style="width: 100%;text-align: center;padding: 20px 0 20px 30px;letter-spacing: 2px;text-transform: uppercase;">Loading...</div>';
    
    this.loadPage(container, 1, row, limit, gridClass);
    
    // Add load more button if needed
    this.addLoadMoreButton(container, row, limit, gridClass);
  },
  
  loadPage(container, page, row, limit, gridClass) {
    const containerElement = document.getElementById(container);
    const state = this.paginationState[container];
    
    if (state.isLoading) return;
    state.isLoading = true;
    
    const request = new XMLHttpRequest();
    request.onreadystatechange = function success() {
      if (request.readyState === 4) {
        state.isLoading = false;
        
        if (request.status === 200) {
          if (page === 1) {
            containerElement.innerHTML = '';
          }
          
          var newContainer = request.responseXML.querySelectorAll("#AjaxinateLoop")[0];
          
          if (!newContainer) {
            console.error('AjaxinateLoop element not found in response');
            if (page === 1) {
              containerElement.innerHTML = '<div style="width: 100%;text-align: center;padding: 20px;">No products found</div>';
            }
            return;
          }
          
          // Update pagination state from response
          state.currentPage = parseInt(newContainer.getAttribute('data-current-page')) || page;
          state.totalPages = parseInt(newContainer.getAttribute('data-total-pages')) || 1;
          state.totalProducts = parseInt(newContainer.getAttribute('data-total-products')) || 0;
          
          console.log(`Page ${state.currentPage} of ${state.totalPages} (${state.totalProducts} total products)`);
          
          if (newContainer.innerHTML.trim() === '') {
            console.log('No products found on page', page);
            if (page === 1) {
              containerElement.innerHTML = '<div style="width: 100%;text-align: center;padding: 20px;">No products found in this collection</div>';
            }
            return;
          }
          
          containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
          
          const products = jQuery(containerElement).find(".grid__item");
          console.log('Found products:', products.length);
          
          jQuery(products).each(function(index,item){
            if(gridClass){
              jQuery(item).removeClass("medium-up--one-quarter small--one-half");
              jQuery(item).addClass(gridClass);
            }
            
            jQuery(item).attr("data-aos",`row-of-${row}`)
          });
          
          // Apply product limit if specified
          if (limit > 0) {
            const allProducts = jQuery(containerElement).find(".grid__item");
            if (allProducts.length > limit) {
              console.log(`Limiting to ${limit} products (found ${allProducts.length})`);
              allProducts.each(function(index, item) {
                if (index >= limit) {
                  jQuery(item).remove();
                }
              });
            }
          }

          setTimeout(formatedGridItemPrice, 60);
          
          // Update load more button visibility
          this.updateLoadMoreButton(container);
          
        } else {
          console.error('Error loading featured products:', request.status);
          if (page === 1) {
            containerElement.innerHTML = '<div style="width: 100%;text-align: center;padding: 20px;">Error loading products</div>';
          }
        }
      }
    }.bind(this);
    
    // Use the collection handle directly
    const collectionHandle = state.collectionHandle;
    console.log(`Fetching page ${page} from collection: ${collectionHandle}`);
    
    request.open('GET', `/collections/${collectionHandle}?view=ajax&page=${page}`);
    request.responseType = 'document';
    request.send();
  },
  
  addLoadMoreButton(container, row, limit, gridClass) {
    const containerElement = document.getElementById(container);
    const loadMoreId = `${container}-load-more`;
    
    // Create load more container if it doesn't exist
    if (!document.getElementById(loadMoreId)) {
      const loadMoreContainer = document.createElement('div');
      loadMoreContainer.className = 'text-center load-more-container';
      loadMoreContainer.style.marginTop = '30px';
      loadMoreContainer.style.marginBottom = '30px';
      loadMoreContainer.id = loadMoreId;
      
      // Insert after the container
      containerElement.parentNode.insertBefore(loadMoreContainer, containerElement.nextSibling);
      
      // Add click handler
      const self = this;
      document.addEventListener('click', function(e) {
        if (e.target && e.target.id === `${loadMoreId}-btn`) {
          e.preventDefault();
          const state = self.paginationState[container];
          if (state && state.currentPage < state.totalPages) {
            self.loadPage(container, state.currentPage + 1, row, 0, gridClass); // Don't apply limit for pagination
          }
        }
      });
    }
    
    // Initial update of the button
    this.updateLoadMoreButton(container);
  },
  
  updateLoadMoreButton(container) {
    const state = this.paginationState[container];
    const loadMoreContainer = document.getElementById(`${container}-load-more`);
    
    if (!loadMoreContainer) return;
    
    if (state.currentPage < state.totalPages) {
      loadMoreContainer.innerHTML = `<button id="${container}-load-more-btn" class="btn">Load More Products</button>`;
    } else {
      // All pages loaded
      loadMoreContainer.innerHTML = '';
    }
  }
}
